//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'bb_form_d_detail',
        data(){
            return{
                get_host:host.host,
                form:{
                    room_number:'',
                    baby_name:'',
                    check_in_time:'',
                    body_heat:'',
                    weight:'',
                    boby_length:'',
                    nutritional_status:'',
                    complexion:'',
                    crying:'',
                    reaction:'',
                    skin_case:'',
                    skin_broken_position:'',
                    skin_rash_position:'',
                    feeding_status:'',
                    milk_brand:'',
                    exc_micturition_case:'',
                    exc_micturition_num:'',
                    exc_defecation_case: '',
                    exc_defecation_num:'',
                    exc_diarrhea_num: '',
                    muscle_status:'',
                    muscle_limited_position:'',
                    muscle_lose_position:'',
                    nursing_problem_status:'',
                    nursing_problem:'',
                    questionText:'',
                    feeding_guidance:'',
                    other_desc: '',
                    cold_prevention:'',
                    family_sign:'',
                    nurse_sign:''
                },
                coldArr:[]
            }
        },
        methods:{
             submitForm(){
                this.$router.replace({
                    path:'/bb_form_d_edit',
                    query:{
                        id:this.$route.query.id,
                        form_id:this.$route.query.form_id,
                        baby_id:this.$route.query.child_id,
                        tabVal: this.$route.query.tabVal
                    }
                })
            },
             goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        tabVal: this.$route.query.tabVal,
                        id: this.$route.query.id
                    }
                })
            }
        },
        created(){
            let params ={
                token:this.$cookie.get('token'),
                id:this.$route.query.form_id
            }
            this.$vux.loading.show({
                text: '正在加载'
            })
            console.info(params)
            Api.otherFormApi.getNewbornFullmoonAssessFind(params).then (res => {
                this.$vux.loading.hide()
                console.info("详情",res.data)
                if(res.errcode==200){
                    this.form.room_number=res.data.room_number
                    this.form.baby_name=res.data.baby_name
                    this.form.check_in_time=res.data.check_in_time
                    this.form.body_heat=res.data.body_heat
                    this.form.weight=res.data.weight
                    this.form.boby_length=res.data.boby_length
                    this.form.nutritional_status=res.data.nutritional_status=='1'?'过剩':(res.data.nutritional_status=='2'?'良好':(res.data.nutritional_status=='3'?'中等':(res.data.nutritional_status=='4'?'差':'')))
                    this.form.complexion=res.data.complexion=='1'?'红润':(res.data.complexion=='2'?'黄染':'')
                    this.form.crying=res.data.crying=='1'?'响亮':(res.data.crying=='2'?'微弱':'')
                    this.form.reaction=res.data.reaction=='1'?'良好':(res.data.reaction=='2'?'迟钝':(res.data.reaction=='3'?'差':''))
                    this.form.skin_case=res.data.skin_case=='1'?'完整':(res.data.skin_case=='2'?'破损':(res.data.skin_case=='3'?'红润':(res.data.skin_case=='4'?'黄染':(res.data.skin_case=='5'?'红臀':(res.data.skin_case=='6'?'干燥':(res.data.skin_case=='7'?'皮疹':''))))))
                    //皮肤
                     let Arr1=res.data.skin_case
                    for(let i=0;i<Arr1.length;i++){
                        if(Arr1[i]=='1'){
                            Arr1[i]='完整'
                        }else if(Arr1[i]=='2'){
                            Arr1[i]='破损'
                        }else if(Arr1[i]=='3'){
                             Arr1[i]='红润'
                        }else if(Arr1[i]=='4'){
                             Arr1[i]='黄染'
                        }else if(Arr1[i]=='5'){
                             Arr1[i]='红臀'
                        }else if(Arr1[i]=='6'){
                            Arr1[i]='干燥'
                        }else if(Arr1[i]=='7'){
                            Arr1[i]='皮疹'
                        }
                        this.form.skin_case=Arr1.join()
                    }
                    this.form.skin_broken_position=res.data.skin_broken_position
                    this.form.skin_rash_position=res.data.skin_rash_position
                    this.form.feeding_status=res.data.feeding_status=='1'?'母乳喂养':(res.data.feeding_status=='2'?'人工喂养':(res.data.feeding_status=='3'?'混合喂养':''))
                    this.form.milk_brand=res.data.milk_brand
                    this.form.exc_micturition_case=res.data.exc_micturition_case=='1'?'正常':''
                    this.form.exc_micturition_num=res.data.exc_micturition_num
                    this.form.exc_defecation_case=res.data.exc_defecation_case=='1'?'正常':(res.data.exc_defecation_case=='2'?'便秘':(res.data.exc_defecation_case=='3'?'未排':(res.data.exc_defecation_case=='4'?'腹泻':'')))
                    this.form.exc_defecation_num=res.data.exc_defecation_num
                    this.form.exc_diarrhea_num=res.data.exc_diarrhea_num
                    this.form.muscle_status=res.data.muscle_status=='1'?'良好':(res.data.muscle_status=='2'?'受限':(res.data.muscle_status=='3'?'丧失':''))
                    this.form.muscle_limited_position=res.data.muscle_limited_position
                    this.form.muscle_lose_position=res.data.muscle_lose_position
                    this.form.nursing_problem_status=res.data.nursing_problem_status=='1'?'有':(res.data.nursing_problem_status=='2'?'无':'')
                    this.form.nursing_problem=res.data.nursing_problem
                    this.form.questionText=res.data.questionText
                    this.form.family_sign=res.data.family_sign.indexOf(this.get_host) != -1 ? res.data.family_sign : this.get_host+res.data.family_sign
                    this.form.nurse_sign=res.data.nurse_sign.indexOf(this.get_host) != -1 ? res.data.nurse_sign : this.get_host+res.data.nurse_sign
                    // this.form.feeding_guidance=res.data.feeding_guidance=='1'?'母乳':(res.data.feeding_guidance=='2'?'牛奶':(res.data.feeding_guidance=='3'?'混合喂养':(res.data.feeding_guidance=='4'?'按时添加辅食':(res.data.feeding_guidance=='5'?'少食多餐':''))))
                    //喂养指导
                    let Arr2=res.data.feeding_guidance
                    for(let i=0;i<Arr2.length;i++){
                        if(Arr2[i]=='1'){
                            Arr2[i]='母乳'
                        }else if(Arr2[i]=='2'){
                            Arr2[i]='牛奶'
                        }else if(Arr2[i]=='3'){
                             Arr2[i]='混合喂养'
                        }else if(Arr2[i]=='4'){
                             Arr2[i]='按时添加辅食'
                        }else if(Arr2[i]=='5'){
                             Arr2[i]='少食多餐'
                        }
                        this.form.feeding_guidance=Arr2.join()
                    }
                    this.form.other_desc=res.data.other_desc
                    //预防感冒
                    let Arr=res.data.cold_prevention.split(',')
                    for(let i=0;i<Arr.length;i++){
                        if(Arr[i]=='1'){
                            Arr[i]='注意保暖'
                        }else if(Arr[i]=='2'){
                            Arr[i]='减少探视'
                        }else if(Arr[i]=='3'){
                             Arr[i]='日光浴'
                        }else if(Arr[i]=='4'){
                             Arr[i]='少到公共场合'
                        }else if(Arr[i]=='5'){
                             Arr[i]='如有不适随时到医院就诊'
                        }
                        this.form.cold_prevention=Arr.join()
                    }

                }
            })
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form_d_detail.vue